import auditType from '@/constants/register/auditType'
import { instance, instanceExternal } from './axios'
import qs from 'qs'

const baseUrl = '/web-api/api/'
const cpUrl = '/web-api/cp/api/'
const ShortLinkUrl = `https://vigco.co/api/v1/shortlink/generates`

const queryCurrencyUrl = `${cpUrl}transfer/currencyList`
const queryCurrencyTo = `${cpUrl}transfer/currencyRate`
const loginUrl = `${baseUrl}login/`
const homeUrl = `${baseUrl}home/`
const withdrawalUrl = `${baseUrl}withdrawal/`
const transferUrl = `${baseUrl}transfer/`
const transferCPUrl = `${cpUrl}transfer/`
const contactUrl = `${baseUrl}contact/`
const commissionUrl = `${baseUrl}commission/`
const tradeaccountUrl = `${baseUrl}tradeaccount/`
const TradeRebateVolumeUrl = `${baseUrl}TradeRebateVolume/`
const foldlineUrl = `${baseUrl}foldline/`
const pieUrl = `${baseUrl}pie/`
const depositUrl = `${cpUrl}deposit/`
const accountUrl = `${cpUrl}account/`
const withdrawalUrlCp = `${cpUrl}withdrawal/`
const userProfileUrl = `${baseUrl}userProfile/`
const ibreportUrl = `${baseUrl}ibreport/`
const reportUrl = `${baseUrl}report/`
const rebateUrl = `${baseUrl}rebate/`
const ibaccountUrl = `${baseUrl}ibaccount/`
const menuUrl = `${baseUrl}menu/`
const identifyProofUrl = `${cpUrl}identityProof/`
const unfundedaccountUrl = `${baseUrl}unfundedaccount/`
const googleTranslateBasic = `https://translation.googleapis.com/language/translate/v2?key=AIzaSyCKuPDmPYUTdOFUitGsQzH3rLgs58B4_I0`
const notificationUrl = `${baseUrl}notification/`
const bannerUrl = `${baseUrl}banner/`
const systemUrl = `${baseUrl}system/`
const paymentSelectionUrl = `${baseUrl}payment/`
const fileUrl = `${baseUrl}file/`
const mfaUrl = `${baseUrl}mfa/`
const securityUrl = `${baseUrl}security/`
const subAccount = `${baseUrl}/sub-account/`
const abTestingUrl = `${baseUrl}ab_testing/`
const fundsUrl = `${baseUrl}funds/`

export const personalDetailUrl = `${baseUrl}personalDetail/`
export const verificationV2Url = `${baseUrl}verificationV2/`
export const questionUrl = `${baseUrl}question/`

/** CPS */
export const cpsWithdrawalUrl = `${withdrawalUrl}`
export const cpsWithdrawalUrlCp = `${withdrawalUrlCp}`

export const securityManageUrl = `${cpUrl}multiFactorAuth/`

/** login */
// export const apiTo_login_by_token = headers => instance.post(`${loginUrl}to_login_by_token`, '', headers)
// export const apiTo_login_by_app = () => instance.post(`${loginUrl}to_login_by_app`, '', { byPassLoading: true })
// export const apiTo_logout = () => instance.get(`${loginUrl}to_logout`)
export const apiGet_cp_url = () => instance.get(`${loginUrl}get_cp_url`)

/** * new login */
// 登录
export const apiTo_login = (data) => instance.post(`/hgw/auth-api/login/customer/pc/to_login`, data)
// // 手机号发送验证码？
// // 登出
export const apiTo_logout = (data) => instance.post(`/hgw/auth-api/login/customer/logout`, data)
// // 获取用户信息
export const apiGetUserInfo = (data) => instance.post(`/hgw/user-api/outer/login/getUserInfo`, data)
/** * new login end */

/**security */
export const apiPreValidateTotp = data => instance.post(`${securityManageUrl}totp/preValidate`, data)
export const apiPreValidateEmail = data => instance.post(`${securityManageUrl}email/preValidate`, data)
export const apiGetSecurityInfo = () => instance.get(`${securityManageUrl}info`)
export const apiGetMultiFactorAuth = functionCode =>
  instance.get(`${securityManageUrl}${functionCode}/getMultiAuthMethod`)
export const apiGetHint = () => instance.get(`${securityManageUrl}hintInfo`)

/** home */
export const apiSetlanguage = data => instance.post(`${userProfileUrl}setlanguage`, qs.stringify(data), { byPassLoading: true })
export const apiQueryRebatesList = (isKeepLoading = false) => {
  return instance.get(`${homeUrl}queryRebatesList`, { byPassLoading: !isKeepLoading })
}
export const apiQueryRebatesBlackList = () => instance.get(`${homeUrl}queryRebatesBlackList`)

export const apiQueryAvailableBalance = data =>
  instance.post(`${homeUrl}queryAvailableBalance`, qs.stringify(data), { byPassLoading: true })
export const apiQueryTotalCommission = data =>
  instance.post(`${homeUrl}queryTotalCommission`, qs.stringify(data), { byPassLoading: true })
export const apiGetNewOpenUserTotal = data =>
  instance.post(`${homeUrl}getNewOpenUserTotal`, qs.stringify(data), { byPassLoading: true })

/** token */
export const apiRequire_token = () => instance.post(`${depositUrl}require_token`)
export const apiAnti_Reuse = () => instance.get(`${baseUrl}token/anti-reuse`)

/** file */
export const apiDelete_file = data => instance.post(`${fileUrl}delete`, data)



/** withdrawal */
export const apiApplyWithdrawal = (data, token) =>
  instance.post(`${withdrawalUrl}applyWithdrawal`, qs.stringify(data), { headers: { token: token } })
export const apiCardInformation = data => instance.get(`${withdrawalUrlCp}queryUnionpayCard`, { param: data })
export const apiGetWithdrawalData = data => instance.post(`${withdrawalUrl}getWithdrawalData`, qs.stringify(data))
export const apiQueryBlacklist = () => instance.get(`${withdrawalUrl}queryBlacklist`)
export const apiWithdrawalQueryRateUSDByTargetCurrency = targetCurrency =>
  instance.get(`${withdrawalUrl}queryRateUSDByTargetCurrency/${targetCurrency}`)
export const apiGetWithdrawalBankCode = () => instance.get(`${withdrawalUrl}queryBankCode`)
export const apiGetWithdrawalBankBranchCode = bankCode => instance.get(`${withdrawalUrl}queryAllByBankCode/${bankCode}`)
export const apiCancelWithdraw = ({ withdrawalId, paymentWithdrawType }) =>
  instance.post(
    `${withdrawalUrl}cancelWithdrawalOrder?withdrawalId=${withdrawalId}&paymentWithdrawType=${paymentWithdrawType}`
  )
export const apiSendEmailVerificationCode = data => instance.post(`${mfaUrl}sendEmailVerificationCode`, data)
export const apiResendOtpSecondLeft = (data) => instance.post(`${mfaUrl}reSendOtpSecondLeft`, data)
/** Payment */
export const apiPaymentSelection = data => instance.post(`${paymentSelectionUrl}info/getPaymentInfoList/`, data)
export const apiPaymentGetInfo = data => instance.post(`${paymentSelectionUrl}info/getInfo/`, data)
export const apiDeleteBankAccountInfo = id =>
  instance.post(`${paymentSelectionUrl}info/deleteBankAccountInfo?bankAccountInfoId=${id}`)
export const apiWithdrawExchangeRate = data =>
  instance.get(`${withdrawalUrlCp}exchangeRate?fromCurrency=${data.fromCurrency}&toCurrency=${data.toCurrency}`)

/** transfer */
// to YOUR accounts
export const apiToApplyTransferView = data => instance.post(`${transferUrl}toApplyTransferView`, qs.stringify(data))
// to OTHERS accounts
export const apiToApplyTransferOthersView = data =>
  instance.post(`${transferUrl}toApplyTransferOthersView`, qs.stringify(data))
// is in transfer-out blacklist
export const apiIsEligibleTransfer = () => instance.get(`${transferUrl}eligible-transfer`)

export const apiDownloadTransferTemplate = data =>
  instance.get(`${transferUrl}download-transfer-template`, qs.stringify(data))
export const apiSub_ib_transfer = (data, token) =>
  instance.post(`${transferUrl}apply/sub-ib-transfer`, data, { headers: { token: token } })
export const apiApplyTransfer = (data, token) =>
  instance.post(`${transferUrl}applyTransfer`, qs.stringify(data), { headers: { token: token } })
export const apiRebateTransferBlacklist = () => instance.get(`${transferCPUrl}queryBlacklist`)
export const apiGetIBTransferUserInfo = data => instance.post(`${transferUrl}sub-ib/info`, data)
//Get transferable currency based on selected account's currency
export const apiGetTransferableCurrency = data => instance.get(`${queryCurrencyUrl}?formCurrency=${data}`)
export const apiGetTransferToRate = data =>
  instance.get(`${queryCurrencyTo}?formCurrency=${data.formCurrency}&&toCurrency=${data.toCurrency}`)

/** contact */
export const apiOwnerinfo = () => instance.post(`${contactUrl}ownerinfo`)
export const apiContactinfo = data => instance.post(`${contactUrl}contactinfo`, qs.stringify(data))

/** commission */
export const apiApplyCommission = data => instance.post(`${commissionUrl}applyCommission`, qs.stringify(data))

/** tradeaccount */
export const apiGetNearestOpenAccount = data =>
  instance.post(`${tradeaccountUrl}getNearestOpenAccount`, qs.stringify(data), { byPassLoading: true })
export const apiGetPendingAccount = data => instance.post(`${tradeaccountUrl}getPendingAccount`, data)

export const apiCheckEquity = data => instance.get(`${accountUrl}check_equity?mt4Account=${data}`)

/** TradeRebateVolume */
export const apiQueryRebateVolumeList = data =>
  instance.post(`${TradeRebateVolumeUrl}queryRebateVolumeList`, qs.stringify(data), { byPassLoading: true })

/** foldline */
export const apiFoldline = (url, data) =>
  instance.post(`${foldlineUrl}${url}`, qs.stringify(data), { byPassLoading: true })

/** pie */
export const apiQueryPieTotalVolumeByGoods = data =>
  instance.post(`${pieUrl}queryPieTotalVolumeByGoods`, qs.stringify(data), { byPassLoading: true })

/** ibreport */
export const apiQueryIbReportData = data => instance.post(`${ibreportUrl}queryIbReportData`, data)
export const apiDownloadIbReportData = (data) =>
  instance.get(
    `${ibreportUrl}downloadIbReportData?userId=${data.userId}&&rebateAccount=${data.rebateAccount}&&startDate=${data.startDate}&&endDate=${data.endDate}&&search=${data.search}&&timeType=${data.timeType}`,
    { responseType: 'blob' }
  )

/** report */
export const apiRebate_report = data => instance.post(`${reportUrl}rebate-report`, data)
export const apiPayer_trade_details = data => instance.post(`${reportUrl}rebate-report/payer-trade-details`, data)
export const apiGet_instruments = data =>
  instance.get(`${reportUrl}get-instruments`, {
    params: data,
  })
export const apiDownloadRebateReportData = data =>
  instance.get(
    `${reportUrl}download-rebate-report?startDate=${data.startDate}&&endDate=${data.endDate}&&account=${data.account}&&symbol=${data.symbol}&&search=${data.search}`,
    { responseType: 'blob' }
  )

/** rebate */
export const apiRebate = (url, data) => instance.post(`${rebateUrl}${url}`, qs.stringify(data))
export const apiAgreement = rebateAccount => instance.get(`${rebateUrl}agreement/account/${rebateAccount}`)
export const apiConfirmAgreement = rebateAccount => instance.post(`${rebateUrl}agreement/sign/${rebateAccount}`)
export const apiGetAgreementUnsignedList = () => instance.post(`${rebateUrl}agreement/unsigned/list`)
export const apiGetAgreementByAuditId = auditId =>
  instance.get(`${rebateUrl}agreement/getAgreementByAuditId/${auditId}`)
export const apiSignAgreementByAuditId = auditId =>
  instance.post(`${rebateUrl}agreement/signAgreementByAuditId/${auditId}`)
export const apiGetAgreementList = () => instance.post(`${rebateUrl}agreement/getAgreementList`)

/** ib account */
export const apiIbAccounts = (url, data) => instance.post(`${ibaccountUrl}${url}`, qs.stringify(data))

/** Trading List */
export const apiGetOpenList = data => instance.post(`${ibaccountUrl}open_trade_list`, qs.stringify(data))
export const apiGetClosedList = data => instance.post(`${ibaccountUrl}close_trade_list`, qs.stringify(data))

/** menu */
export const apiLeads = data => instance.post(`${menuUrl}leads`, data)

/** unfunded account */
export const apiGetAccsByUrl = (url, data) => instance.post(`${unfundedaccountUrl}${url}`, qs.stringify(data))

/** all retail account */
export const apiRetailAccs = data => instance.post(`${unfundedaccountUrl}queryRetailAccounts`, qs.stringify(data))
export const apiTransactionHistory = data =>
  instance.post(`${ibaccountUrl}queryDepositWithdrawalHistory`, qs.stringify(data))


/** transactionHistory */
export const apiDownloadIbFundsRebatesPdf = data =>
  instance.post(`${fundsUrl}downloadIbFundsRebatesPdf`, data)
export const apiDownloadIbFundsWithdrawalsPdf = data =>
  instance.post(`${fundsUrl}downloadIbFundsWithdrawalsPdf`, data)
export const apiDownloadIbFundsTransfersPdf = data =>
  instance.post(`${fundsUrl}downloadIbFundsTransfersPdf`, data)

/** notification */
export const apiGetNotifications = ({ country }) => instance.get(`${notificationUrl}enabled?country=${country}`, { byPassLoading: true })

/** banner */
// displayPlatform standadize with BE (BannerDisplayPlatformEnum) & Admin (displayPlatformEnum)
// displayPage standadize with BE (BannerDisplayPageEnum) & CP (popupBannerDisplayPageEnum)
export const apiGetBanners = ({ country, displayPage }) =>
  instance.get(`${bannerUrl}enabled?displayPlatform=2&country=${country}&displayPage=${displayPage}`, {
    byPassLoading: true,
  })
export const apiSnoozeBanner = notificationIdList => instance.post(`${bannerUrl}snooze`, { notificationIdList })

/** systemUrl */
export const apiInformation = () => instance.get(`${systemUrl}information`)

/** currency rate */
// get currencies which has currency rate
export const apiGetFormCurrencyData = data => instance.get(`${queryCurrencyUrl}?formCurrency=${data}`)
// get rate between to currencies
export const apiGetFormCurrencyTo = data =>
  instance.get(`${queryCurrencyTo}?formCurrency=${data.formCurrency}&&toCurrency=${data.toCurrency}`)
// get currency rate convert from USD
export const apiQueryRateUSDByTargetCurrency = currency =>
  instance.post(`${depositUrl}queryRateUSDByTargetCurrency`, qs.stringify({ targetCurrency: currency }))

/** identityProof */
// export const apiVerificationIdentityProofs = data => instance.post(`${identifyProofUrl}verification`, data)
// export const apiCheckRecordExists = data => instance.post(`${identifyProofUrl}check_record_exists`, data)
export const apiGet_last_identifiy_proof = (documentTypeId, auditTypeId = auditType.general) =>
  instance.get(`${identifyProofUrl}get_last_identifiy_proof?documentType=${documentTypeId}&auditType=${auditTypeId}`)
export const apiAttach_new_document = data => instance.post(`${identifyProofUrl}attach_new_document`, data)
export const apiUpdate_user_id_address = data => instance.post(`${identifyProofUrl}updateUserIdAddress`, data)
// export const apiDoId3 = data => instance.post(`${identifyProofUrl}doID3`, data)
export const apiVerificationV2 = data => instance.post(`${identifyProofUrl}verificationV2`, data)

/** security */
export const apiGetSecurity = () => instance.get(`${securityUrl}getSecuritys`)

/** profile */
export const apiUpdateSubAccount = data => instance.post(`${subAccount}edit`, data)
export const apiGetSubAccountList = () => instance.get(`${subAccount}list`)
export const apiPostSubAccountChange = data => instance.post(`${subAccount}enable`, data)
export const apiGetSubAccountHistoryList = ({ pageNo, pageSize, subId }) =>
  instance.get(`${subAccount}history/page?pageNo=${pageNo}&pageSize=${pageSize}${subId ? `&subId=${subId}` : ''}`)
export const apiPostSubPasswordChange = data => instance.post(`${subAccount}reset-password`, data)

/* referralLinks */
export const apiGetShortLink = data => instanceExternal.post('https://vtm.pro/api/v1/shortlink/generate', data)

/** guide */
export const apiHomeReadGuide = data => instance.get(`${homeUrl}readGuide`, data)
export const apiIbReportReadGuide = data => instance.get(`${ibreportUrl}readGuide`, data)
export const apiIbAccountReadGuide = data => instance.get(`${ibaccountUrl}readGuide`, data)
export const apiHomeDoneGuide = data => instance.post(`${homeUrl}readGuide`, data)
export const apiIbReportDoneGuide = data => instance.post(`${ibreportUrl}readGuide`, data)
export const apiIbAccountDoneGuide = data => instance.post(`${ibaccountUrl}readGuide`, data)

export const apiEncryptPublicKey = (token = null) => instance.get(`${cpUrl}keyPair/pk?token=${token}`)

/**session */
export const apiGetSessionId = () => instance.get(`${baseUrl}tool/session-id`, { byPassLoading: true })

// abTesting
export const apiGetAbTestingEligible = abTemplateDisplayPage =>
  instance.get(`${abTestingUrl}eligible/${abTemplateDisplayPage}`)
export const apiSubmitAbTesting = data => instance.post(`${abTestingUrl}submit`, data)

/**跑马灯 */
// 获取跑马灯消息通知
export const apiGetActivityTicker = (data) => instance.get(`/web-api/api/home/activity/ticker`, data)

/** 切换域名联动 */
export const apiGetDomainLinkage = ({rebateAccount}) => instance.get(`${baseUrl}domain/ibReferral?rebateAccount=${rebateAccount}`)